import { Datepicker } from '@acpaas-ui/react-components';
import { SEARCH_FIELD_TYPES } from '../../../constants/advanced.search.constants';
import { INPUT_STATES } from '../../forms/forms.utils';
import SelectField from '../../forms/SelectField';
import TextField from '../../forms/TextField';

const AdvancedSearchField = ({
  name,
  label,
  value,
  fieldProps,
  breakAfter,
  options,
  isLoadingDependency,
  loadDependencyError,
  onChange,
  onEnter,
  type
}) => {
  const handleEnter = (e) => {
    if (e.code === 'Enter') {
      onEnter();
    }
  };

  const handleChange = (value) => {
    onChange(value, name);
  };

  const renderField = () => {
    const sharedProps = {
      label,
      value,
      onChange: handleChange,
      ...fieldProps
    };

    switch (type) {
      case SEARCH_FIELD_TYPES.SINGLE_SELECT:
        return (
          <SelectField
            {...sharedProps}
            hasError={!!loadDependencyError}
            description={loadDependencyError}
            isSubmitting={isLoadingDependency}
            options={options}
            allOption
          />
        );
      case SEARCH_FIELD_TYPES.MULTIPLE_SELECT:
        return (
          <SelectField
            {...sharedProps}
            hasError={!!loadDependencyError}
            description={loadDependencyError}
            isSubmitting={isLoadingDependency}
            value={value || []}
            multiple
            options={options}
            allOption
          />
        );
      case SEARCH_FIELD_TYPES.DATE:
        return <Datepicker {...sharedProps} activeDate={value} mask={'99/99/9999'} />;

      default:
        return <TextField {...sharedProps} state={INPUT_STATES.DEFAULT} onKeyDown={handleEnter} />;
    }
  };

  return (
    <>
      <div className="spo-m-advanced-search-field col-xs-12 col-md-4">{renderField()}</div>
      {breakAfter && <div className="spo-m-advanced-search-field__break"></div>}
    </>
  );
};

export default AdvancedSearchField;
